import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-melissa-ink text-melissa-bg py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-6">
            <p className="text-xs uppercase tracking-overline text-melissa-bg/60 mb-6">Melissa O'Donnell</p>
            <h3 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight">
              Refined artistry.
              <br />
              <em className="italic text-melissa-rose">Timeless faces.</em>
            </h3>
          </div>
          <div className="md:col-span-2">
            <p className="text-[10px] uppercase tracking-overline text-melissa-bg/60 mb-4">Browse</p>
            <ul className="space-y-3 font-serif text-lg">
              <li><a href="#portfolio" data-testid="footer-link-portfolio" className="hover:text-melissa-rose">Portfolio</a></li>
              <li><a href="#services" data-testid="footer-link-services" className="hover:text-melissa-rose">Services</a></li>
              <li><a href="#about" data-testid="footer-link-about" className="hover:text-melissa-rose">About</a></li>
              <li><a href="#contact" data-testid="footer-link-contact" className="hover:text-melissa-rose">Contact</a></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-overline text-melissa-bg/60 mb-4">Reach Out</p>
            <a
              href="mailto:melissaruthodonnell@gmail.com"
              data-testid="footer-email"
              className="font-serif text-lg hover:text-melissa-rose block"
            >
              melissaruthodonnell@gmail.com
            </a>
            <p className="font-serif text-lg mt-2">By appointment · NYC & travel</p>
            <div className="mt-6 flex gap-4 text-[10px] uppercase tracking-overline text-melissa-bg/60">
              <a href="#" className="hover:text-melissa-rose" data-testid="footer-instagram">Instagram</a>
              <a href="#" className="hover:text-melissa-rose" data-testid="footer-pinterest">Pinterest</a>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-melissa-bg/15 flex flex-col md:flex-row justify-between gap-4 text-[10px] uppercase tracking-overline text-melissa-bg/50">
          <span>© {new Date().getFullYear()} Melissa O'Donnell · All rights reserved</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-melissa-rose">
            Admin Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}
